import { Injectable } from '@angular/core';
import { KYMW7004Model } from '../kymw7004.model';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 特集商品提案状況更新サービス
 * @export UpdateFeatureRequestListService
 * @class UpdateFeatureRequestListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateFeatureRequestListService extends PlessJsonResponderSub<null> {

  model: KYMW7004Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateFeatureRequestListService
   */
  private getBody(): PlessRequest {
    const updObj = {
      OrderCodeList: {
        combination: this.model.updatefeatureRequestLists.map(_ => 
          ({
          parameter: {
            OrderCode: _.OrderCode,
          }
        })),
      },
    };
    if (updObj.OrderCodeList.combination.length < 1)
      delete updObj.OrderCodeList;
    return new PlessRequest({ update: updObj });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof UpdateFeatureRequestListService
   */
  execute(model: KYMW7004Model, f?: () => void): void {
    this.model = model;
    if (f) this.calbak = f;
    this.send('updateFeatureRequestList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof UpdateFeatureRequestListService
   */
  success() {
    if (this.calbak) this.calbak();
  }

}
